// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rb-admin {
  font-family: Arial, sans-serif;
  padding: 2%;
}

.h2 {
  text-align: left;
  margin-bottom: 20px;
}

.rb-filters {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 5% 0;
}

.rb-filter-group {
  display: flex;
  align-items: center;
  gap: 10px;
  height: 36px;
  margin-bottom: 5px;
}

.rb-filter-group label {
  font-weight: bold;
}

.rb-filter-group select {
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 5px;
  height: 35px;
  font-size: medium;
}

.rb-filter-group input {
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 5px;
  height: 26px;
  font-size: medium;
}

.rb-search {
  background-color: #79c42b;
  color: white;
  border: none;
  padding: 1% 3%;
  font-size: medium;
  cursor: pointer;
  border-radius: 5px;
  display: flex;
  align-items: center;
  gap: 5px;
  height: 36px;
}

.rb-search:hover {
  background-color: #0056b3;
}

.rb-atable-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.employee-section {
  background: #fff;
}

.employee-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  cursor: pointer;
  background: #fff;
  transition: background 0.3s;
}

.employee-row:hover {
  background: #f0f0f0;
}

.rb-sub-container {
  background: #fff;
}

.rb-sub-table {
  padding: 0;
  width: 100%;
  border-collapse: collapse;
  overflow: visible;
}

.rb-sub-table th {
  background-color: #f2f2f2;
  padding: 8px;
  border: 2px solid #ddd;
  min-width: 60px;
}

.rb-sub-table td {
  padding: 8px;
  border: 1px solid #ddd;
  text-align: center;
  position: relative;
  overflow: visible;
}

.rb-sub-table td:nth-child(4) {
  text-align: right;
}

.update-btn:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.update-btn {
  margin-right: 20%;
}

.no-data {
  text-align: center;
  font-style: italic;
  color: gray;
}

.emp-rows {
  width: 25%;
  color: #949494;
}

.emp-rows span {
  color: #000;
  font-weight: bold;
}

.empId-rows {
  color: #949494;
  width: 40%;
}

.empId-rows span {
  color: #000;
  font-weight: bold;
  margin-right: 2%;
}

.status-label {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 6px 12px;
  border-radius: 12px;
  font-weight: bold;
  text-transform: capitalize;
}

.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.approved {
  background-color: #e6f9ed;
  color: #0f9d58;
}

.approved .status-dot {
  background-color: #0f9d58;
}

.rejected {
  background-color: #fde8e8;
  color: #d32f2f;
}

.rejected .status-dot {
  background-color: #d32f2f;
}

.rb-status-dropdown {
  width: 90px;
  padding: 6px;
  border-radius: 5px;
  border: 1px solid #ccc;
  background-color: white;
  cursor: pointer;
}

.rb-sub-table input {
  width: 90px;
  padding: 5%;
  border-radius: 5px;
}

.rbadmin-comments {
  max-width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
}

td:hover .rbadmin-comments {
  white-space: normal;
  overflow: visible;
  text-overflow: unset;
  word-wrap: break-word;
  display: block;
  max-width: 200px;
}

td:hover {
  height: auto;
}

.rb-sub-table,
.rb-sub-container {
  overflow: visible !important;
}

.modal-cross-btn {
  background: none;
  border: none;
  padding-bottom: 2%;
  font-size: 18px;
  cursor: pointer;
  color: #fff;
}

.payment-header {
  display: flex;
  justify-content: space-between;
  padding: 0 2%;
  background-color: #00468c;
  color: #fff;
}

.payment-header h3 {
  margin: 1% 0;
  padding-bottom: 2%;
}

.payment-options {
  padding: 4%;
}

.pending-payment-btn {
  border: 2px solid #fbb751;
  background-color: white;
  color: #fbb751;

  padding: 5px 10px;
  cursor: pointer;
  border-radius: 4px;
}

.submit-payment-btn {
  background-color: #4caf50;
  color: white;
  border: none;
  padding: 8px 12px;
  cursor: pointer;
  border-radius: 4px;
  margin-top: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Reimbursement/RbAdmin.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;;EAEd,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB","sourcesContent":[".rb-admin {\n  font-family: Arial, sans-serif;\n  padding: 2%;\n}\n\n.h2 {\n  text-align: left;\n  margin-bottom: 20px;\n}\n\n.rb-filters {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin: 5% 0;\n}\n\n.rb-filter-group {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  height: 36px;\n  margin-bottom: 5px;\n}\n\n.rb-filter-group label {\n  font-weight: bold;\n}\n\n.rb-filter-group select {\n  padding: 5px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  height: 35px;\n  font-size: medium;\n}\n\n.rb-filter-group input {\n  padding: 5px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  height: 26px;\n  font-size: medium;\n}\n\n.rb-search {\n  background-color: #79c42b;\n  color: white;\n  border: none;\n  padding: 1% 3%;\n  font-size: medium;\n  cursor: pointer;\n  border-radius: 5px;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  height: 36px;\n}\n\n.rb-search:hover {\n  background-color: #0056b3;\n}\n\n.rb-atable-container {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.employee-section {\n  background: #fff;\n}\n\n.employee-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px;\n  cursor: pointer;\n  background: #fff;\n  transition: background 0.3s;\n}\n\n.employee-row:hover {\n  background: #f0f0f0;\n}\n\n.rb-sub-container {\n  background: #fff;\n}\n\n.rb-sub-table {\n  padding: 0;\n  width: 100%;\n  border-collapse: collapse;\n  overflow: visible;\n}\n\n.rb-sub-table th {\n  background-color: #f2f2f2;\n  padding: 8px;\n  border: 2px solid #ddd;\n  min-width: 60px;\n}\n\n.rb-sub-table td {\n  padding: 8px;\n  border: 1px solid #ddd;\n  text-align: center;\n  position: relative;\n  overflow: visible;\n}\n\n.rb-sub-table td:nth-child(4) {\n  text-align: right;\n}\n\n.update-btn:disabled {\n  background-color: #ccc;\n  cursor: not-allowed;\n}\n\n.update-btn {\n  margin-right: 20%;\n}\n\n.no-data {\n  text-align: center;\n  font-style: italic;\n  color: gray;\n}\n\n.emp-rows {\n  width: 25%;\n  color: #949494;\n}\n\n.emp-rows span {\n  color: #000;\n  font-weight: bold;\n}\n\n.empId-rows {\n  color: #949494;\n  width: 40%;\n}\n\n.empId-rows span {\n  color: #000;\n  font-weight: bold;\n  margin-right: 2%;\n}\n\n.status-label {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  padding: 6px 12px;\n  border-radius: 12px;\n  font-weight: bold;\n  text-transform: capitalize;\n}\n\n.status-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n}\n\n.approved {\n  background-color: #e6f9ed;\n  color: #0f9d58;\n}\n\n.approved .status-dot {\n  background-color: #0f9d58;\n}\n\n.rejected {\n  background-color: #fde8e8;\n  color: #d32f2f;\n}\n\n.rejected .status-dot {\n  background-color: #d32f2f;\n}\n\n.rb-status-dropdown {\n  width: 90px;\n  padding: 6px;\n  border-radius: 5px;\n  border: 1px solid #ccc;\n  background-color: white;\n  cursor: pointer;\n}\n\n.rb-sub-table input {\n  width: 90px;\n  padding: 5%;\n  border-radius: 5px;\n}\n\n.rbadmin-comments {\n  max-width: 100px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: block;\n}\n\ntd:hover .rbadmin-comments {\n  white-space: normal;\n  overflow: visible;\n  text-overflow: unset;\n  word-wrap: break-word;\n  display: block;\n  max-width: 200px;\n}\n\ntd:hover {\n  height: auto;\n}\n\n.rb-sub-table,\n.rb-sub-container {\n  overflow: visible !important;\n}\n\n.modal-cross-btn {\n  background: none;\n  border: none;\n  padding-bottom: 2%;\n  font-size: 18px;\n  cursor: pointer;\n  color: #fff;\n}\n\n.payment-header {\n  display: flex;\n  justify-content: space-between;\n  padding: 0 2%;\n  background-color: #00468c;\n  color: #fff;\n}\n\n.payment-header h3 {\n  margin: 1% 0;\n  padding-bottom: 2%;\n}\n\n.payment-options {\n  padding: 4%;\n}\n\n.pending-payment-btn {\n  border: 2px solid #fbb751;\n  background-color: white;\n  color: #fbb751;\n\n  padding: 5px 10px;\n  cursor: pointer;\n  border-radius: 4px;\n}\n\n.submit-payment-btn {\n  background-color: #4caf50;\n  color: white;\n  border: none;\n  padding: 8px 12px;\n  cursor: pointer;\n  border-radius: 4px;\n  margin-top: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
